<script lang="ts" setup>
import { defineAsyncComponent } from 'vue'
// components
const BasketErrorMessage = defineAsyncComponent(
  () => import('@/components/Basket/basket-utils/BasketErrorMessage.vue'),
)

defineProps({
  errors: {
    type: Array,
    required: true,
  },
})
</script>

<template>
  <div class="gifts-info">
    <basket-error-message
      v-if="errors.length !== 0"
      :error-message="errors[0]"
    />

    <span v-else>В подарок не входят соусы, добавьте их отдельно</span>
  </div>
</template>

<style lang="scss" scoped>
.gifts-info {
  min-height: 25px;
  font-size: 14px;
  font-weight: 600;
  color: $dark-grey;
}
</style>
